import React, { useState } from "react";
import { Link } from "react-router-dom";
import Storage from "../../utils/storage";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Button from "../../components/Button/Button";

const Application = () => {
  const [state, setstate] = useState({
    active1: false,
    active2: false,
    route: "",
  });

  let userStatus = Storage.get("user-access-data");
  
  const user = JSON.parse(userStatus);
  let name = user && user.name;

  const setActiveClass1 = () => {
    setstate({
      ...state,
      active1: true,
      active2: false,
      route: "/device/details",
    });
  };

  const setActiveClass2 = () => {
    setstate({
      ...state,
      active1: false,
      active2: true,
      route: "/application/details",
    });
  };

  return (
    <div className="application">
      <Link to="/dashboard">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>

      <div className="application-start-form">
        <div className="application-start-form-header">
          <h1>Hello {name}</h1>
          <h3>
            What do you want to <br /> apply for?
          </h3>
          <p>Choose from the options provided below</p>
        </div>

        <div className="application-start-form-body">
          <div className={state.active1 ? "green-bg" : null}>
            <div className="upper" onClick={setActiveClass1}>
              <div className="upper-image"></div>
              <div className="upper-content">
                <h4>Apply for Device certification</h4>
                <p>
                  *Device certification gives you access to all benefits on your
                  POS device
                </p>
              </div>
            </div>
          </div>

          <div className={state.active2 ? "green-bg" : null}>
            <div className="upper" onClick={setActiveClass2}>
              <div className="lower-image"></div>
              <div className="upper-content">
                <h4>Apply for Application certification</h4>
                <p>
                  *Application certification gives you access to all benefits on
                  your POS application
                </p>
              </div>
            </div>
          </div>
        </div>

        <Link to={state.route}>
          <Button
            width="100%"
            height="45px"
            word={"SEND"}
            disabled={state.route === ""}
          />
        </Link>
      </div>
    </div>
  );
};

export default Application;
